import DateRange from './schema/DateRange';

export default class CalendarEventsDateRangeStore {
    private activeDateRange: DateRange = null;
    private dateRangeAlreadyFetched: DateRange = null;

    setDateRange(activeDateRange: DateRange) {
        this.activeDateRange = activeDateRange;
    }

    getDateRange() {
        return this.activeDateRange;
    }

    setDateRangeAlreadyFetched(dateRangeAlreadyFetched: DateRange) {
        this.dateRangeAlreadyFetched = dateRangeAlreadyFetched;
    }

    getDateRangeAlreadyFetched() {
        return this.dateRangeAlreadyFetched;
    }
}
